import React from "react";
import { motion } from "framer-motion";

const Hero = () => {
  return (
    <section className="h-screen flex flex-col justify-center items-center text-center px-6 snap-start">
      <motion.h1
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="text-5xl font-bold text-secondary-500"
      >
        Build the Future with Elseware Technology
      </motion.h1>
      <motion.p
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.3 }}
        className="text-xl mt-4 text-light-300"
      >
        Enterprise Software | Web Development | AI Solutions
      </motion.p>
      <motion.button
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="mt-6 px-8 py-3 bg-secondary-500 text-dark-900 rounded-lg font-bold text-lg"
      >
        Get Started
      </motion.button>
    </section>
  );
};

export default Hero;